//TODO:  this is a quick and dirty number formatting pipe.    Need to handle other formats later.   Perhaps extend to currency pipe?
// Supports the following resolutions 22, $23.3K,  $1.5M etc.
// the only format option supported currently is "$MK"

// This was copied from the portfolio app

import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'epNumber',
    standalone: false
})
export class NumberPipe implements PipeTransform {
    transform(value: string, format: string) {
        if (!value) {
            return value;
        }

        let amount = +value;

        let result = '';
        if (format != '$MK') {
            return 'INVALID_FORMAT';
        }
        if (Math.abs(amount) > 999999.99) {
            // if over 1 million than conver to $xx.xM format
            amount = Math.round((amount / 1000000) * 10) / 10;
            result = '$' + amount.toString() + 'M';
        } else if (Math.abs(amount) > 9999.99) {
            // if over 10,000 than conver to $xx.xK format
            amount = Math.round((amount / 1000) * 10) / 10;
            result = '$' + amount.toString() + 'K';
        } else {
            amount = Math.round(amount);
            if (amount > 999) {
                var temp = amount.toString();
                result = '$' + temp.slice(0, 1) + ',' + temp.slice(1);
            } else if (amount < -999) {
                var temp = amount.toString();
                result = '$' + temp.slice(0, 2) + ',' + temp.slice(2);
            } else if (amount == 0) {
                result = '$0';
            } else {
                result = '$' + amount.toString();
            }
        }
        return result;
    }
}
